module.exports = __webpack_public_path__ + "static/media/bannerv1.88f9479.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bannerv1.mp4
// module id = EUXQ
// module chunks = 37